const seoPage = {
  displayField: 'metaTitle',
  name: 'SEOPage',
  description: '',
  fields: [
    {
      id: 'metaTitle',
      name: 'Meta Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'metaDescription',
      name: 'Meta Description',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'openGraphImage',
      name: 'Open Graph Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'schema',
      name: 'Schema',
      type: 'Object',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'seoPage', version: 2, updatedAt: '2023-05-11T20:35:40.106Z' }
};
export default seoPage;